import { makeUseAxios } from "axios-hooks";

import { Config } from "@/utils/config.utils";

import { createApiFor, ExtendedUseAxios } from "./utils";

const useProductServiceApi = makeUseAxios({
    axios: createApiFor(`/productservice/${Config.general.basestore}`),
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;

const bffProductServiceAxiosInstance = createApiFor(
    `/${Config.general.basestore}`,
    {
        bff: true
    }
);

const useBFFProductService = () => {
    return bffProductServiceAxiosInstance;
};

const useBFFProductServiceApi = makeUseAxios({
    axios: bffProductServiceAxiosInstance,
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;

export { useBFFProductService, useBFFProductServiceApi, useProductServiceApi };
